// Promise-based dialogs preserve each caller's confirmation/cancellation flow.
let queue = [];
let nextId = 0;
const listeners = new Set();
export const subscribeDialogs = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export const getDialog = () => queue[0] || null;
const notify = () => listeners.forEach(listener => listener());
const request = (type, message, defaultValue = '') => new Promise(resolve => {
  queue = [...queue, { id: ++nextId, type, message: String(message), defaultValue: String(defaultValue ?? ''), resolve }];
  notify();
});
export const appAlert = message => request('alert', message);
export const appConfirm = message => request('confirm', message);
export const appPrompt = (message, defaultValue) => request('prompt', message, defaultValue);
export function settleDialog(dialog, value) {
  if (queue[0] !== dialog) return;
  queue = queue.slice(1);
  dialog.resolve(value);
  notify();
}
